import { action } from 'easy-peasy';

import { IActionSetChannel } from '../types';

const setChannel: IActionSetChannel = action((state, payload) => {
  state.current = payload;
});

export default setChannel;
